module.exports = __webpack_public_path__ + "img/otkrit.ea29d779.png";